import lodash from "lodash"

import { createAtomFamily } from "utils/recoil"

export const stateStateFamily = createAtomFamily({
  prefix: "containers/TariffsDialog",
  key: "state"
})
